// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"51734ace","949":"7c3b3877"}[chunkId] + ".chunk.js";
};